import { useState } from 'react'
import { EuiButton,	EuiPopover } from '@equipmentshare/ds2'
import ApproveTransactionPopover from '../ApproveTransactionPopover'

export type AwaitingApprovalStatusProps = {
  label: string,
  transactionId: number,
}

export default function AwaitingApprovalStatus( { label, transactionId }: AwaitingApprovalStatusProps ) {
	const [ isOpen, setIsOpen ] = useState( false )

	const togglePopover = () => setIsOpen( !isOpen )
	const closePopover = () => setIsOpen( false )

	const button = (
		<EuiButton
			id="popover-btn"
			color="text"
			onClick={togglePopover}
		>
			{label}
		</EuiButton>
	)

	return (
		<EuiPopover
			button={button}
			isOpen={isOpen}
			closePopover={closePopover}
		>
			<ApproveTransactionPopover
				closePopover={closePopover}
				transactionId={transactionId}
			/>
		</EuiPopover>
	)
}
